// assets/product-tabs.js
(function() {
  const tabs = document.querySelectorAll('[data-tabs]');
  tabs.forEach(scope => {
    const triggers = scope.querySelectorAll('[data-tab-target]');
    const panels = scope.querySelectorAll('[data-tab]');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const target = trigger.dataset.tabTarget;
        triggers.forEach(t => {
          t.classList.toggle('pr-tab--active', t === trigger);
          t.setAttribute('aria-selected', t === trigger ? 'true' : 'false');
        });
        panels.forEach(p => {
          const isActive = p.dataset.tab === target;
          p.classList.toggle('pr-tab-content--active', isActive);
          if (isActive) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      });
    });
  });
})();
